import { type PropsWithChildren, Fragment } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { keySecurityAuthorization } from '@/api/query-keys';
import Authorizor from '@/util/authorizor';

interface NotAuthorizedProps extends PropsWithChildren {
    path?: string; // if defined, navigate to this path if not authorized.
}

export default function NotAuthorized(props: NotAuthorizedProps) {
    const navigate = useNavigate();
    const { getToken } = useAuth();
    const { data, isLoading } = useQuery({
        queryKey: keySecurityAuthorization(), 
        queryFn: async () => {
            return Authorizor.authorize(getToken);
        }
    });

    if (isLoading) {
        return null;
    }

    if (data) {
        if (props.path) {
            navigate({ to: props.path, viewTransition: true });
        }
        return null;
    }

    return (
        <Fragment>
            {props.children }
        </Fragment>
    )
    
}